var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_183",
    "data-name": "Group 183",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    d: "M15 16H.9a.987.987 0 0 1-.9-1V.9A.9.9 0 0 1 .9 0h11.4a.713.713 0 0 1 .6.3l2.8 3a.6.6 0 0 1 .3.6V15a1.075 1.075 0 0 1-1 1zM1.8 14.2h12.4v-10l-2.4-2.4h-10z",
    className: "cls-1",
    "data-name": "Path 193"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    d: "M10.4 7.1h-7a.967.967 0 0 1-.9-.9V1a.9.9 0 0 1 .9-.9.876.876 0 0 1 .8.9v4.3h5.3V1.4a.9.9 0 1 1 1.8 0v4.8a.9.9 0 0 1-.9.9z",
    className: "cls-1",
    "data-name": "Path 194"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    d: "M8 4.4a.9.9 0 0 1-.9-.9V1A.9.9 0 0 1 8 .1a.967.967 0 0 1 .9.9v2.5a.9.9 0 0 1-.9.9z",
    className: "cls-1",
    "data-name": "Path 195"
  }))));
}
export default __webpack_public_path__ + "static/media/ic_save.bf283d5d.svg";
export { SvgIcSave as ReactComponent };